/* Theme – global behaviour (no dependencies). */
(() => {
  const theme = window.theme || {};
  const routes = theme.routes || {};
  const t = theme.strings || {};
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const sectionUrl = (id) => `${routes.root}${String(routes.root).endsWith('/') ? '' : '/'}?sections=${id}`;

  /* ---------------- Toast ---------------- */
  let toastTimer;
  function toast(msg) {
    const el = $('[data-toast]');
    if (!el) return;
    $('[data-toast-text]', el).textContent = msg;
    el.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('show'), 2200);
  }

  /* ---------------- Cart ---------------- */
  const openCart = () => document.body.classList.add('cart-open');
  const closeCart = () => document.body.classList.remove('cart-open');

  async function refreshCart() {
    const res = await fetch(sectionUrl('cart-drawer'));
    const data = await res.json();
    const doc = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
    const fresh = doc.querySelector('.shopify-section') || doc.body;
    const current = document.getElementById('shopify-section-cart-drawer');
    if (current) current.innerHTML = fresh.innerHTML;
    const count = $('[data-cart-drawer]')?.dataset.count;
    if (count !== undefined) $$('[data-cart-count]').forEach((el) => { el.textContent = count; });
  }

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form.js-ajax-cart');
    if (!form) return;
    e.preventDefault();
    const button = $('[type="submit"]', form);
    const error = $('[data-form-error]', form);
    if (button) button.setAttribute('aria-disabled', 'true');
    if (error) error.hidden = true;
    try {
      const res = await fetch(`${routes.cartAdd}.js`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      });
      const json = await res.json();
      if (!res.ok) throw new Error(json.description || json.message || t.cartError);
      await refreshCart();
      const name = button?.dataset.name || json.product_title || json.title || '';
      toast((t.added || '[name]').replace('[name]', name).trim());
      if (form.hasAttribute('data-open-drawer')) openCart();
    } catch (err) {
      if (error) { error.textContent = err.message; error.hidden = false; }
      else toast(err.message);
    } finally {
      if (button) button.removeAttribute('aria-disabled');
    }
  });

  /* ---------------- Clicks ---------------- */
  document.addEventListener('click', async (e) => {
    const change = e.target.closest('[data-line-change]');
    if (change) {
      e.preventDefault();
      await fetch(`${routes.cartChange}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(change.dataset.line), quantity: Number(change.dataset.qty) })
      });
      await refreshCart();
      return;
    }
    if (e.target.closest('[data-open-cart]') && !document.body.classList.contains('template-cart')) {
      e.preventDefault();
      openCart();
      return;
    }
    if (e.target.closest('[data-close-cart]')) { closeCart(); return; }

    /* Mobile menu: opens the nav row (and the search field) */
    if (e.target.closest('[data-menu-toggle]')) {
      $('[data-nav]')?.classList.toggle('open');
      $('[data-header-search]')?.classList.toggle('is-open');
      return;
    }

    /* Tabs (product lists etc.) */
    const tab = e.target.closest('[data-tab]');
    if (tab) {
      const root = tab.closest('[data-tabs]');
      $$('[data-tab]', root).forEach((b) => {
        const on = b === tab;
        b.classList.toggle('active', on);
        b.setAttribute('aria-selected', on);
      });
      $$('[data-panel]', root).forEach((p) => { p.hidden = p.dataset.panel !== tab.dataset.tab; });
      return;
    }

    /* Hero game chips → set the vendor filter of the search */
    const chip = e.target.closest('[data-chip]');
    if (chip) {
      const form = chip.closest('form');
      $$('[data-chip]', form).forEach((c) => c.classList.toggle('active', c === chip));
      const input = $('[data-chip-value]', form);
      if (input) { input.value = chip.dataset.vendor || ''; input.disabled = !chip.dataset.vendor; }
      return;
    }

    /* Carousel arrows */
    const arrow = e.target.closest('[data-scroll]');
    if (arrow) {
      const track = document.getElementById(arrow.getAttribute('aria-controls'));
      if (track) track.scrollBy({ left: Number(arrow.dataset.scroll) * track.clientWidth * 0.8, behavior: 'smooth' });
      return;
    }

    /* Flip cards */
    const flip = e.target.closest('[data-flip]');
    if (flip && !e.target.closest('a')) { flip.classList.toggle('flipped'); return; }

    /* Product thumbnails */
    const thumb = e.target.closest('[data-thumb]');
    if (thumb) {
      const main = $('.js-main-image');
      if (main) { main.src = thumb.dataset.thumb; main.srcset = ''; }
      $$('[data-thumb]').forEach((x) => x.classList.toggle('is-active', x === thumb));
      return;
    }

    /* Demo products (shown until a collection is chosen) */
    const demoAdd = e.target.closest('[data-demo-add]');
    if (demoAdd) {
      toast((t.added || '[name]').replace('[name]', demoAdd.dataset.name || '').trim());
      return;
    }

    /* Quantity steppers */
    const step = e.target.closest('[data-qty-step]');
    if (step) {
      const input = $('input', step.closest('.qty'));
      input.value = Math.max(1, Number(input.value || 1) + Number(step.dataset.qtyStep));
    }
  });

  /* ---------------- Mega menu ---------------- */
  /* Desktop: open on hover; only one open at a time; close on outside click / Escape. */
  const megaHover = window.matchMedia('(hover: hover) and (min-width: 901px)');
  const closeMegas = (except) => $$('[data-mega][open]').forEach((d) => { if (d !== except) d.open = false; });
  $$('[data-mega]').forEach((d) => {
    let timer;
    d.addEventListener('toggle', () => { if (d.open) closeMegas(d); });
    d.addEventListener('mouseenter', () => { if (!megaHover.matches) return; clearTimeout(timer); d.open = true; });
    d.addEventListener('mouseleave', () => { if (!megaHover.matches) return; timer = setTimeout(() => { d.open = false; }, 180); });
  });
  document.addEventListener('click', (e) => { if (!e.target.closest('[data-mega]')) closeMegas(); });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { closeCart(); closeMegas(); }
    const flip = e.target.closest && e.target.closest('[data-flip]');
    if (flip && e.target === flip && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      flip.classList.toggle('flipped');
    }
  });

  /* ---------------- Variant picker & auto-submit ---------------- */
  document.addEventListener('change', (e) => {
    const select = e.target.closest('[data-variant-select]');
    if (select) {
      const root = select.closest('[data-product]');
      const data = JSON.parse($('[data-variants]', root).textContent);
      const variant = data.find((v) => String(v.id) === select.value);
      if (!variant) return;
      const price = $('[data-price]', root);
      if (price) price.innerHTML = variant.compare ? `<s>${variant.compare}</s>${variant.price}` : variant.price;
      const button = $('form [type="submit"]', root);
      if (button) {
        button.disabled = !variant.available;
        button.textContent = variant.available ? t.addToCart : t.soldOut;
      }
      $('[data-stock]', root)?.classList.toggle('is-out', !variant.available);
      if (variant.image) {
        const main = $('.js-main-image', root);
        if (main) { main.src = variant.image; main.srcset = ''; }
      }
      const url = new URL(location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
      return;
    }
    const auto = e.target.closest('[data-auto-submit]');
    if (auto) (auto.form || auto.closest('form'))?.submit();
  });

  /* ---------------- Section initialisers ---------------- */
  function initRotators(root) {
    $$('[data-rotator]', root).forEach((rot) => {
      if (rot.dataset.ready) return;
      rot.dataset.ready = '1';
      const items = $$('p:not([data-live-only])', rot);
      if (items.length < 2) return;
      let i = 0;
      setInterval(() => {
        if (!rot.hasAttribute('data-rotator')) return;
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, Number(rot.dataset.rotator) || 5000);
    });
  }

  /* Loyalty tiers */
  function initLoyalty(root) {
    $$('[data-loyalty]', root).forEach((box) => {
      if (box.dataset.ready) return;
      box.dataset.ready = '1';
      const tiers = JSON.parse($('[data-loyalty-data]', box).textContent);
      const show = (n) => {
        const d = tiers[n];
        if (!d) return;
        $('[data-mc-tier]', box).textContent = d.name;
        $('[data-mc-perk]', box).textContent = d.perk;
        $('[data-mc-spend]', box).textContent = '€' + d.spend;
        $('[data-member-card]', box).style.setProperty('--glow', d.glow);
        $('[data-perks]', box).innerHTML = d.perks.map(([b, txt]) => `<li><b>${b}</b>${txt}</li>`).join('');
      };
      box.addEventListener('click', (e) => {
        const b = e.target.closest('.tier-tabs button');
        if (!b) return;
        $$('.tier-tabs button', box).forEach((x) => x.classList.toggle('active', x === b));
        show(Number(b.dataset.t));
      });
      show(0);
    });
  }

  /* Collection page: view toggle, filter drawer, in-page search, price slider, banner */
  const store = {
    get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { localStorage.setItem(k, v); } catch (e) { /* storage blocked */ } }
  };

  function initCollection(root) {
    $$('[data-collection]', root).forEach((coll) => {
      if (coll.dataset.ready) return;
      coll.dataset.ready = '1';
      const grid = $('[data-coll-grid]', coll);

      /* Grid / list view (remembered per visitor) */
      const setView = (view) => {
        if (grid) grid.classList.toggle('is-list', view === 'list');
        $$('[data-view]', coll).forEach((b) => b.classList.toggle('is-on', b.dataset.view === view));
        store.set('coll_view', view);
      };
      setView(store.get('coll_view') === 'list' ? 'list' : 'grid');
      coll.addEventListener('click', (e) => {
        const v = e.target.closest('[data-view]');
        if (v) setView(v.dataset.view);
        if (e.target.closest('[data-filter-toggle]')) {
          const open = coll.classList.toggle('filters-open');
          document.body.style.overflow = open ? 'hidden' : '';
        }
        const x = e.target.closest('[data-dismiss-btn]');
        if (x) {
          const box = x.closest('[data-dismiss]');
          store.set('dismiss_' + box.dataset.dismiss, '1');
          box.hidden = true;
        }
      });
      $$('[data-dismiss]', coll).forEach((box) => { if (store.get('dismiss_' + box.dataset.dismiss)) box.hidden = true; });

      /* Search within the loaded products */
      const search = $('[data-coll-search]', coll);
      const noMatch = $('[data-coll-nomatch]', coll);
      if (search && grid) {
        const cards = $$('[data-ccard]', grid);
        const norm = (s) => String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
        search.addEventListener('input', () => {
          const q = norm(search.value.trim());
          let shown = 0;
          cards.forEach((c) => {
            const ok = !q || norm(c.dataset.title).includes(q);
            c.hidden = !ok;
            if (ok) shown += 1;
          });
          if (noMatch) {
            noMatch.hidden = shown > 0;
            const link = $('[data-coll-search-link]', noMatch);
            if (link) link.href = `${routes.search}?q=${encodeURIComponent(search.value.trim())}`;
          }
        });
      }

      /* Dual price slider */
      $$('[data-price-range]', coll).forEach((box) => {
        const max = Number(box.dataset.max) || 100;
        const lo = $('[data-price-min]', box);
        const hi = $('[data-price-max]', box);
        const fill = $('[data-price-fill]', box);
        const from = $('[data-price-from]', box);
        const to = $('[data-price-to]', box);
        const loField = $('[data-price-min-field]', box);
        const hiField = $('[data-price-max-field]', box);
        const paint = () => {
          let a = Number(lo.value);
          let b = Number(hi.value);
          if (a > b) [a, b] = [b, a];
          fill.style.left = `${(a / max) * 100}%`;
          fill.style.right = `${100 - (b / max) * 100}%`;
          from.textContent = `€${a}`;
          to.textContent = `€${b}`;
          return [a, b];
        };
        const commit = () => {
          const [a, b] = paint();
          loField.value = a > 0 ? a : '';
          hiField.value = b < max ? b : '';
          box.closest('form').submit();
        };
        [lo, hi].forEach((input) => {
          input.addEventListener('input', paint);
          input.addEventListener('change', commit);
        });
        paint();
      });
    });
  }

  /* TikTok live state (switch "We zijn nu live" in the theme settings) */
  function initLive() {
    const cfg = theme.live || {};
    if (!cfg.handle) return;
    const profile = 'https://www.tiktok.com/@' + cfg.handle;
    const apply = () => {
      const live = cfg.on === true;
      document.body.classList.toggle('is-live-now', live);
      $$('[data-live-state]').forEach((el) => el.classList.toggle('is-live', live));
      $$('[data-live-text]').forEach((el) => { el.textContent = live ? el.dataset.on : el.dataset.off; });
      /* every link to the profile goes to the running live while live */
      $$('a[href*="tiktok.com/@' + cfg.handle + '"]').forEach((a) => {
        if (a.closest('[data-live-only]')) return;
        a.href = live ? profile + '/live' : profile;
      });
    };
    apply();
  }

  /* "Vaak samen gekocht": fetch Shopify recommendations (complementary → related fallback) */
  function initRecs(root) {
    $$('[data-recs]', root).forEach(async (box) => {
      if (box.dataset.ready) return;
      box.dataset.ready = '1';
      const intents = [box.dataset.intent, box.dataset.fallback].filter(Boolean);
      for (const intent of intents) {
        try {
          const res = await fetch(`${box.dataset.url}&intent=${intent}`);
          if (!res.ok) continue;
          const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
          const fresh = doc.querySelector('[data-recs]');
          if (fresh && fresh.querySelector('.product')) {
            box.innerHTML = fresh.innerHTML;
            box.classList.add('is-loaded');
            return;
          }
        } catch (e) { /* network error: leave the section empty */ }
      }
    });
  }

  function init(root = document) {
    initRotators(root);
    initCollection(root);
    initLoyalty(root);
    initRecs(root);
  }

  document.addEventListener('DOMContentLoaded', () => { init(); initLive(); });
  document.addEventListener('shopify:section:load', (e) => init(e.target));

  window.PackportTheme = { refreshCart, openCart, closeCart, toast };
})();
